import {createAction, props} from "@ngrx/store";
import {Serializer} from "../../interfaces/serializer";
import {AdRReportType, AdRequestParams, AdReportParams} from '../../interfaces/ad-reports';
import {ComponentType} from '@angular/cdk/overlay';
import {DashboardWidget, DashboardWidgetConfig} from './report-dashboard';

export const reportDownload = createAction(
  '[REPORT] DOWNLOAD',
  props<{
    params: Partial<AdRequestParams>,
    reportData: any,
    format: string,
    separator: string
  }>()
);
export const reportDownloadSuccess = createAction('[REPORT] DOWNLOAD SUCCESS');
export const reportDownloadError = createAction('[REPORT] DOWNLOAD ERROR');

export const reportShareMail = createAction(
  '[REPORT] SHARE MAIL',
  props<{
    params: Partial<AdRequestParams>,
    emails: string,
    reportType: AdRReportType,
    reportId: number,
    name: string,
    format: string
  }>()
);
export const reportShareMailSuccess = createAction('[REPORT] SHARE MAIL SUCCESS');
export const reportShareMailError = createAction('[REPORT] SHARE MAIL ERROR');

export const reportShareDestination = createAction(
  '[REPORT] SHARE DESTINATION',
  props<{
    params: Partial<AdRequestParams>,
    destination: Serializer<any>,
    reportType: AdRReportType,
    reportId: number,
    name: string,
    format: string
  }>()
);
export const reportShareDestinationSuccess = createAction('[REPORT] SHARE DESTINATION SUCCESS');
export const reportShareDestinationError = createAction('[REPORT] SHARE DESTINATION ERROR');

export const reportOpenSaveDialog = createAction('[REPORT] OPEN SAVE DIALOG', (data) => data || ({ exit: false }));
export const reportOpenSendDialog = createAction('[REPORT] OPEN SHARE DIALOG');
export const reportOpenShareWithLinkDialog = createAction('[REPORT] OPEN SHARE WITH LINK DIALOG');
export const reportOpenExitDialog = createAction('[REPORT] OPEN EXIT DIALOG');
export const reportOpenNewLinkDialog = createAction('[REPORT] OPEN NEW LINK DIALOG', props<{ link: string }>());
export const reportOpenDownloadDialog = createAction('[REPORT] OPEN DOWNLOAD DIALOG', props<{ format: string, separator: string }>());

export const reportOpenPeriodDialog = createAction('[REPORT] OPEN PERIOD DIALOG', props<{ disableComparison: boolean }>());

export const reportExit = createAction('[REPORT] EXIT');

export const reportUpdateSettings = createAction('[REPORT] UPDATE SETTINGS',props<{ settings: any }>());

export const reportDashboardAddWidget = createAction('[REPORT_DASHBOARD] ADD WIDGET', props<{ widget: ComponentType<any>, params: Partial<AdReportParams>, config: Partial<DashboardWidgetConfig>, dashboard: Partial<DashboardWidget>[] }>());

export const reportDashboardUpdateWidget = createAction('[REPORT_DASHBOARD] UPDATE WIDGET', props<{ widget: DashboardWidget, params: Partial<AdReportParams>, config: Partial<DashboardWidgetConfig>, dashboard: Partial<DashboardWidget>[] }>());

export const reportDashboardUpdateWidgets = createAction('[REPORT_DASHBOARD] UPDATE WIDGETS', props<{ dashboard: DashboardWidget[] }>())

